import React from "react";
import "./HighlightServicesCard.css"; // Dedicated styles for the individual card component
import { Link } from "react-router-dom";

const HighlightServicesCard = ({ title, icon, link }) => {
  return (
    <Link to={link} target="_blank">

    <div className="service-card-wrapper">
      <div className="icon-box">
        <img className="icon-placeholder" src={icon} alt={`${title} icon`} />
      </div>
      <span className="service-title">{title}</span>
    </div>
    </Link>
  );
};

export default HighlightServicesCard;